import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface VideoErrorStateProps {
    hasArchive: boolean;
    canGoLive: boolean;
}

export function VideoErrorState({
    hasArchive,
    canGoLive,
}: VideoErrorStateProps) {
    const { t } = useTranslation(I18nNamespace.VIDEO);

    return (
        <div className="flex items-center justify-center w-full h-full bg-black-100">
            <div className="text-center text-grey-300 px-8">
                <p className="text-lg font-medium mb-2">
                    {hasArchive
                        ? t('streaming.messages.failedToLoadVideo')
                        : t('streaming.messages.noArchivedVideo')}
                </p>
                {canGoLive && (
                    <p className="text-sm text-grey-400">
                        {t('streaming.messages.cameraIsLive')}
                    </p>
                )}
                {!canGoLive && !hasArchive && (
                    <p className="text-sm text-grey-400">
                        {t('streaming.messages.cameraOfflineNoRecordings')}
                    </p>
                )}
            </div>
        </div>
    );
}
